import FormattedMessage from 'I18n/components/FormattedMessage';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { DEFAULT_HELP_TEXT_COLOR } from 'visitor-ui-component-library/theme/ColorConstants';
import { adjustLuminance } from 'visitor-ui-component-library/utils/adjustLuminance';
import { getHideNewThreadLink } from '../../query-params/getHideNewThreadLink';
import { NEUTRAL_1600 } from 'visitor-ui-component-library/constants/WidgetColors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewThreadpromptContainer = styled.div.withConfig({
  displayName: "NewThreadPrompt__NewThreadpromptContainer"
})(["padding:32px 20px 12px 20px;text-align:center;width:100%;"]);
const StartNewChatButton = styled.button.withConfig({
  displayName: "NewThreadPrompt__StartNewChatButton"
})(({
  $textColor
}) => css(["background:none;border:none;color:", ";cursor:pointer;font:inherit;transition:color 0.15s ease;&:hover{color:", ";}&:focus-visible{outline:2px solid ", ";outline-offset:2px;border-radius:2px;}"], $textColor, adjustLuminance($textColor, 20), NEUTRAL_1600));
function NewThreadPrompt({
  accentColor,
  createNewThread,
  useDefaultColor
}) {
  const textColor = useDefaultColor ? DEFAULT_HELP_TEXT_COLOR : accentColor;
  const hideNewThreadLink = getHideNewThreadLink();
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsxs(NewThreadpromptContainer, {
      role: "status",
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newHeading",
          options: {
            locale
          }
        })
      }), !hideNewThreadLink && /*#__PURE__*/_jsx(StartNewChatButton, {
        onClick: createNewThread,
        $textColor: textColor,
        "data-test-id": "visitor-widget-start-new-thread-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newButton",
          options: {
            locale
          }
        })
      })]
    })
  });
}
NewThreadPrompt.propTypes = {
  accentColor: PropTypes.string.isRequired,
  createNewThread: PropTypes.func.isRequired,
  useDefaultColor: PropTypes.bool.isRequired
};
NewThreadPrompt.displayName = 'NewThreadPrompt';
export default NewThreadPrompt;